import { arrayToObjectCovert } from '../../../../services/commonService';

const handleFetchRolesFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.roles = arrayToObjectCovert(action.payload.data);
  state.rolesOrder = action.payload.data.map(role => role.id);
  state.currentPage = action.payload.current_page;
  state.perPage = action.payload.limit;
  state.totalPages = action.payload.total_pages;
  state.totalRoles = action.payload.total_count;
  state.lastUpdated = action.payload.last_updated;
  state.message = action.payload.message;
};

const handleDeleteRoleFulfilled = (state, action) => {
  state.status = 'succeeded';
  const roleId = action.payload.data.role_id;
  if (state.roles && state.roles[roleId]) {
    delete state.roles[roleId];
  }
  state.message = action.payload.message;
};

const handleAddRoleFulfilled = (state, action) => {
  state.status = 'succeeded';
  const roleId = action.payload.data.id;
  if (!state.roles[roleId]) {
    state.roles[roleId] = [];
  }
  state.roles[roleId].push(action.payload.data);
  state.message = action.payload.message;
};

const handleFetchRoleByIdFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentRole = action.payload.data;
};

const handleUpdateRoleFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.roles[action.payload.data.id] = action.payload.data;
  state.currentRole = action.payload.data;
  state.message = action.payload.message;
};

export {
  handleFetchRolesFulfilled,
  handleDeleteRoleFulfilled,
  handleAddRoleFulfilled,
  handleFetchRoleByIdFulfilled,
  handleUpdateRoleFulfilled,
};
